import { FieldProps } from 'formik';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import FormSelect from 'components/ui/composed/declarations/formSelect/DeclarationSelect';
import useCodelists from 'hooks/useCodelists';
import { AvailableForms } from 'hooks/useHideEntities';
import DeclarationField from 'views/declarations/common/DeclarationField';
import CustomsOfficeOfExitBlock from 'views/declarations/uk/export/blocks/CustomsOfficeOfExitBlock';
import { validators } from 'views/declarations/uk/export/validations/validations';
import { getFormikProps } from 'views/declarations/utils/form-utils';

export type PostMirrorField = {
    // Path into the master level form values
    path: string;
    render: () => ReactNode;
    required?: boolean;
};

const IdentificationOfLocationField = () => {
    const { t } = useTranslation('form');
    const { cdsCodelists } = useCodelists();

    return (
        <DeclarationField pathPrefix="goodsShipment.consignment.goodsLocation" name="name">
            {({ form, field }: FieldProps<any>) => (
                <FormSelect
                    refNumber="5/23"
                    label={t('locationGoods.identificationOfLocation')}
                    {...getFormikProps(field.name, form)}
                    selectOptions={cdsCodelists?.unLocodes}
                    condensed
                    codeValidation={[validators.maxLength(35)]}
                    getPopupContainer={() => document.body}
                />
            )}
        </DeclarationField>
    );
};

export const POST_MIRROR_FIELDS_BY_FORM: Partial<Record<AvailableForms, PostMirrorField[]>> = {
    UK_EXPORT_B1: [
        {
            path: 'exitOffice.id',
            render: () => <CustomsOfficeOfExitBlock />,
            required: true,
        },
        {
            path: 'goodsShipment.consignment.goodsLocation.name',
            render: () => <IdentificationOfLocationField />,
        },
    ],
};
